import { useState, useEffect } from "react";
import { saveGLDetails, getAllBanks } from "../Api/GLMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const GLMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId; 

  const [glData, setGLData] = useState({
    companyCode: "",
    code: "",
    description: "",
    type1: "",
    type2: "",
    type3: "",
    accountType: "",
    bankCode: ""
  });

  const companyOptions = [
    { value: "1000", label: "1000 - STPL" },
    { value: "2000", label: "2000 - Bizflow" },
    { value: "3000", label: "3000 - Discovery Wines" }
  ];

  const accountTypeOptions = [
    { value: "C", label: "C" },
    { value: "V", label: "V" },
    { value: "A", label: "A" },
    { value: "G", label: "G" },
    { value: "M", label: "M" }
  ];

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const data = await getAllBanks();
        setBanks(data);
      } catch (error) {
        toast.error("Failed to load banks");
      }
    };
    fetchBanks();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGLData({
      ...glData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveGLDetails(glData, userId);
      toast.success(`🦄 GL Master Added Successfully`);
      setGLData({
        companyCode: "",
        code: "",
        description: "",
        type1: "",
        type2: "",
        type3: "",
        accountType: "",
        bankCode: ""
      });
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save GL details"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">GL Master</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Company Code <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      as="select"
                      name="companyCode" 
                      value={glData.companyCode} 
                      onChange={handleChange} 
                      required
                    >
                      <option value="">Select Company</option>
                      {companyOptions.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Code <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="code" 
                      value={glData.code} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="description" 
                      value={glData.description} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Type 1</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="type1" 
                      value={glData.type1} 
                      onChange={handleChange} 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Type 2</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="type2" 
                      value={glData.type2} 
                      onChange={handleChange} 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Type 3</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="type3" 
                      value={glData.type3} 
                      onChange={handleChange} 
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account Type <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      as="select"
                      name="accountType" 
                      value={glData.accountType} 
                      onChange={handleChange} 
                      required
                    >
                      <option value="">Select Account Type</option>
                      {accountTypeOptions.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Bank Code</Form.Label>
                    <Form.Control 
                      as="select"
                      name="bankCode" 
                      value={glData.bankCode} 
                      onChange={handleChange}
                    >
                      <option value="">Select Bank</option>
                      {banks.map(bank => (
                        <option key={bank.code} value={bank.code}>
                          {bank.code} - {bank.description}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save GL Master
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default GLMaster;